/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_Connection_CanceledInputs */

const en_integration_connection_canceled = /** @type {(inputs: Integration_Connection_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connection canceled. You can connect whenever you are ready.`)
};

const es_integration_connection_canceled = /** @type {(inputs: Integration_Connection_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conexión cancelada. Puedes conectarte cuando quieras.`)
};

/**
* | output |
* | --- |
* | "Connection canceled. You can connect whenever you are ready." |
*
* @param {Integration_Connection_CanceledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connection_canceled = /** @type {((inputs?: Integration_Connection_CanceledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connection_CanceledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connection_canceled(inputs)
	return en_integration_connection_canceled(inputs)
});